import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store"
import AppSettings from "@/settings/appSettings"

class PORTAL_CerereDocumentService {
  getODataStore() {
    return new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + "PORTAL_CerereDocument",
      key: "ID",
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
      }
    });
  }

  add(data: any): Promise<any> {
    return http.clientPortalHR.post("/portal/cerere-document", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  addWithFile(tipId: string, descriere: string, file?: File): Promise<any> {
    const fd = new FormData();
    fd.append("TipCerereDocumentID", tipId);
    if (descriere) fd.append("Descriere", descriere);
    if (file) fd.append("file", file);
    return http.clientPortalHRUpload.post("/portal/cerere-document", fd, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_CerereDocumentService();
